module.exports = __webpack_public_path__ + "media/images/common/logo_bg_09-b93f9b9581565e87cb1209cd883933be.png";